import React from 'react';

import { ClassName, TableViewType } from '../../../../../types';
import { ProjectTeam } from '../../../../projects/projectsTypes';

import { IndexTableCell } from '../IndexTableCell';
import { TeamAvatarLink } from '../../../../teams/helpers/TeamAvatarLink';

interface IndexTableCellTeamAvatarProps {
  avatarType?: 'main' | 'xl' | 'xs';
  divClassName?: ClassName;
  tdClassName?: ClassName;
  team: ProjectTeam;
  viewType?: TableViewType;
  withLibraryLink?: boolean;
}

function IndexTableCellTeamAvatar({
  avatarType = 'main',
  divClassName,
  tdClassName,
  team,
  viewType,
  withLibraryLink
}: IndexTableCellTeamAvatarProps) {
  return (
    <IndexTableCell
      viewType={viewType}
      tdClassName={tdClassName}
      divClassName={divClassName}
    >
      <TeamAvatarLink
        team={team}
        avatarType={avatarType}
        withLibraryLink={withLibraryLink}
      />
    </IndexTableCell>
  );
}

export default IndexTableCellTeamAvatar;
